// Centralized snackbar duration values for consistent UX
export const SNACKBAR_DURATION = {
  SHORT: 1000,
  NORMAL: 2000,
  MEDIUM: 2500,
  LONG: 5000,
};
